import styled from "@emotion/styled";

import { fontRoboto } from "shared/lib/styles";

export const FacebookIframe = styled.iframe`
  margin-inline-start: 12px;

  border: none;

  overflow: hidden;
`;

export const Description = styled.div`
  color: #6f6f6f;
  font-size: 12px;
  font-family: ${fontRoboto};
  line-height: 16px;
`;

export const Container = styled.div`
  display: grid;
  grid-template-areas: "Description LikeWidget";

  ${FacebookIframe} {
    grid-area: LikeWidget;
  }

  ${Description} {
    grid-area: Description;
  }
`;
